<template>
    <div class="ErrorMessage">
        <warning-icon class="ErrorMessage-icon"></warning-icon>
        {{message}}
    </div>
</template>

<script>
    import WarningIcon from './warning-icon.vue'

    export default {
        components: {
            WarningIcon
        },
        props: {
            message: {
                types: [String, Object]
            }
        },
    }
</script>
